<span>
    {{text}}
</span>

<div mat-dialog-actions align='center'>
    <button mat-raised-button color="warn" mat-dialog-close >Cancel</button>
    <button mat-raised-button color="primary"  (click)="sendvalues()">Continua</button>
  </div>